export const initialized = state => state.initialized
export const loading = state => state.loading
export const isExpired = (state) => () => {
    const expirationDate =
      state.expirationDate instanceof Date
        ? state.expirationDate
        : new Date(state.expirationDate)

    return expirationDate < new Date()
}
export const regionPages = state => state.regionPages
export const regionPageByName = state => name => state.regionPages.find(regionPage => regionPage.region.name === name)
export const regionPageBySlug = state => slug => state.regionPages.find(regionPage => regionPage.region.slug === slug)
